module.exports = __webpack_public_path__ + "static/aiIntro-912d7d6f0983833cfeb3b985f470c8d9.gif";